import React from "react";
import MatchCenter from "../components/MatchCenter";

function Admin() {
  return <MatchCenter />;
}

export default Admin;
